import React, { forwardRef, useEffect, useRef } from "react";

import styles from "./SearchInput.module.css";

const SearchInput = forwardRef((props, forwardedRef) => {
  const {
    value,
    placeholder,
    onChange,
    onKeyUp,
    onKeyDown,
    multiline = false,
  } = props;

  const localRef = useRef(null);
  const activeRef = forwardedRef || localRef;

  useEffect(() => {
    if (multiline && activeRef.current) {
      const ta = activeRef.current;
      ta.style.height = "auto";
      ta.style.height = `${ta.scrollHeight}px`;
    }
  }, [value, multiline]);

  return (
    <div className={styles.wrapper}>
      <div className={styles.svgWrapper}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="auto"
          height="auto"
          viewBox="0 0 24 24"
        >
          <path
            d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5
              16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16
              9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5
              4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99
              5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14
              9.5 14z"
          ></path>
        </svg>
      </div>
      {multiline ? (
        <textarea
          className={styles.textarea}
          ref={activeRef}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
          rows={1}
        />
      ) : (
        <input
          className={styles.textarea}
          ref={activeRef}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onKeyUp={onKeyUp}
          onKeyDown={onKeyDown}
        />
      )}
    </div>
  );
});

export default SearchInput;
